export interface FlareStyle {
  readonly halo: number;
  readonly extension: number;
  readonly exposure: number;
  readonly stroke: number;
  readonly blur: number;
  readonly followSeconds: number;
}

export const ORIGINAL_FLARE: FlareStyle = {
  halo: 10,
  extension: 0.6,
  exposure: 1,
  stroke: 0.9,
  blur: 1,
  followSeconds: 0,
};

/** Gallery study 04, selected for the landing-page CTAs. */
export const SOFT_ATMOSPHERE: FlareStyle = {
  ...ORIGINAL_FLARE,
  halo: 40,
  blur: 3,
};

/** Project a screen-space light toward the pill, preserving direction at any distance.
 * A smooth bound keeps a distant cursor luminous instead of clamping to a corner.
 */
export function screenLight(
  cursor: readonly [number, number],
  rect: { left: number; top: number; width: number; height: number },
  halo: number,
): readonly [number, number] {
  const dx = cursor[0] - rect.left - rect.width / 2;
  const dy = cursor[1] - rect.top - rect.height / 2;
  const rx = Math.max(1, rect.width / 2 - halo);
  const ry = Math.max(1, rect.height / 2 - halo);
  const scale = 1 / Math.sqrt(1 + (dx / rx) ** 2 + (dy / ry) ** 2);
  return [
    0.5 + (dx * scale) / Math.max(1, rect.width),
    0.5 + (dy * scale) / Math.max(1, rect.height),
  ];
}
